import {createContext} from 'react';

export type DashContextType = {
    opened: boolean;
    openDash: () => void;
    closeDash: () => void;
}
export const DashContext = createContext<DashContextType>(null!);